import { Box, Grid, LinearProgress, Paper, Stack, SvgIcon, Typography } from '@mui/material'
import CustomToolTip from '../../common/toolTip';
import ChargeLevelChart from './chargeLevelChart'
import { 
    batteryIconPath
  } from '../../../components/common/iconPaths'
import custom from '../../../styles/mui/szVariables.json'

export default function ChargeLevelCard({ id, content, monitor }: any) {
    return (
        <Paper id={id+'ChargeLevel'} elevation={0} 
            sx={{ 
                borderRadius: custom.corners6, 
                mx: custom.spacing.sm,
                mt: custom.spacing.sm,
                p: custom.spacing.md,
                width: "100%" 
            }} >               
            <Grid container direction="column" 
                justifyContent="start" 
                alignItems="flex-left" 
                display="flex" >
                    <Grid item mb={custom.spacing.md}>
                        <Stack alignItems="center" 
                                direction="row" 
                                justifyContent="flex-end">
                            <Typography sx={{ 
                                    color: 'text.secondary'
                                }} 
                                variant="szHeading.Bold.xSmall" 
                                id={id+'ChargeLevelTitle'}>
                                    {content.monitorTitle}
                            </Typography>
                            <CustomToolTip message={content.toolTip} offset={[0,-10]}>
                                <Box component={"img"} id="tooltip"
                                    ml="auto" 
                                    p={custom.spacing.xxxs}    
                                    alt="info icon"
                                    src="/images/information.svg"
                                />
                            </CustomToolTip>
                        </Stack>
                    </Grid>
                    <Grid item mb={custom.spacing.sm}>
                        <Stack alignItems="center" 
                            direction="row" 
                            justifyContent="flex-end" >
                            <Box>
                                <Typography 
                                    variant="szHeading.Bold.xLarge" 
                                    id={id+'ChargeLevelPercent'}>
                                    {content.charged}
                                    <Typography pl={custom.spacing.xxxxs} 
                                        variant="szHeading.Bold.xSmall" >
                                            {content.unit}
                                    </Typography>
                                </Typography>
                                <Typography pt="3px" component={"p"} 
                                    variant="szHeading.Bold.xSmall" >
                                        Charged
                                </Typography>
                            </Box>
                            <SvgIcon sx={{ 
                                        ml:'auto', 
                                        color: 'battery.main', 
                                        fontSize: '3rem'
                                    }}> 
                                    {batteryIconPath} 
                            </SvgIcon>
                        </Stack>
                    </Grid>
                    <Grid item mb={custom.spacing.xxs}>
                        <Box width="100%" id={id+'ChargeLevelProgressbar'}>
                            <LinearProgress variant="determinate" 
                                value={content.charged} 
                                color={monitor}
                                sx={{
                                    height: '24px',
                                    borderRadius: custom.corners2,
                                    backgroundColor: 'sz.colors.surfaceWellSmall'
                                }}/>
                        </Box>
                    </Grid>
                    <Grid item >
                        <ChargeLevelChart 
                            id={id} 
                            content={content} 
                            tickInterval={
                                ['12am','3','6','9','1pm','4 ',
                                    '7 ','9 ','11 ']
                            } 
                            margin={{
                                left: 20,
                                right: 40,
                                top: 20,
                                bottom: 20,
                            }}/>
                    </Grid>
            </Grid>
        </Paper>
    )
}